import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import utils from "@/common/utils";

Vue.config.productionTip = false
Vue.use(ElementUI);
// 首页浏览埋点
utils.setExecute({
  "type": "shangHaiTanExecute",//类型
  "PageId": "ShangHaiTanPointsLists",//页面ID
  "EventType": "homeEnter",//事件类型
  "EventName": "首页浏览",//事件名称
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
